import { Injectable } from '@angular/core';
import { DataService as CoreDataService } from '@barthauer/abc/core/data';
@Injectable({
  providedIn: 'root',
})
export class SubProjectService {
  public subProjectReports;

  constructor(private coreDataService: CoreDataService) {}

  public prepareEvents(): void {}
}
